import React from 'react';
import { Theme } from '~/styles';
import { ModalTitle, ModalText } from './styles';
import { ActionArea } from '../../styles';
import { Button, Modal } from '~/shared/components';
import PropTypes from 'prop-types';

const ScheduleExamModal = ({
  isScheduleModalOpen,
  handleCloseScheduleModal,
  modalTitle,
  modalText,
  primaryButtonText,
  secondaryButtonText,
}) => {
  return (
    <Modal
      isOpen={isScheduleModalOpen}
      widthContainer="350px"
      heightContainer="330px"
      title="Agendar Exames"
      onCloseRequest={() => handleCloseScheduleModal(false)}
    >
      <ModalTitle>{modalTitle}</ModalTitle>
      <ModalText>{modalText}</ModalText>
      <ActionArea width="240px">
        <Button
          variant="outlined"
          onClick={() => handleCloseScheduleModal(true)}
        >
          {primaryButtonText}
        </Button>
        <Button
          margin={`${Theme.spacing.small} 0 0 0`}
          onClick={() => handleCloseScheduleModal(false)}
        >
          {secondaryButtonText}
        </Button>
      </ActionArea>
    </Modal>
  );
};

ScheduleExamModal.propTypes = {
  isScheduleModalOpen: PropTypes.bool.isRequired,
  handleCloseScheduleModal: PropTypes.func.isRequired,
  modalTitle: PropTypes.string.isRequired,
  modalText: PropTypes.node.isRequired,
  primaryButtonText: PropTypes.string.isRequired,
  secondaryButtonText: PropTypes.string.isRequired,
};

export default ScheduleExamModal;
